import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {authenticationT} from '@/lib/types/authentication.types';

const AUTHENTICATION_INITIAL: authenticationT = {
  createdAt: undefined,
  updatedAt: undefined,
  removedAt: undefined,
  token: ``,
};

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState: {
    ...AUTHENTICATION_INITIAL,
  },
  reducers: {
    AUTHENTICATION_UPDATE: (
      state,
      action: PayloadAction<{data?: authenticationT; prop?: string; value?: string | Date}>
    ) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? {[action.payload.prop]: action.payload.value} : null),
      });
    },
  },
});

const {AUTHENTICATION_UPDATE} = authenticationSlice.actions;

export {authenticationSlice, AUTHENTICATION_INITIAL, AUTHENTICATION_UPDATE};
